import { decode } from 'qss';

interface Query {
  locale?: string;
}

export const getUrlLocale = (): string => {
  const query: Query = decode(window.location.search.substr(1));
  return query.locale || '';
};
